import * as React from 'react'

const LogoWhatsapp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill="#601E82"
      d="M16.129 3.793A8.6 8.6 0 0 0 9.996 1.25 8.681 8.681 0 0 0 2.48 14.258L1.25 18.75l4.598-1.207a8.65 8.65 0 0 0 4.144 1.055h.004c4.777 0 8.754-3.891 8.754-8.672 0-2.317-.984-4.492-2.621-6.133M9.996 17.137a7.2 7.2 0 0 1-3.672-1.004l-.261-.156-2.727.714.727-2.66-.172-.273a7.2 7.2 0 0 1-1.102-3.836c0-3.973 3.234-7.207 7.211-7.207 1.926 0 3.734.75 5.094 2.113S17.289 8 17.285 9.926c0 3.976-3.316 7.21-7.289 7.21m3.953-5.399c-.215-.11-1.281-.633-1.48-.703-.2-.074-.344-.11-.489.11-.144.218-.558.703-.687.851-.125.145-.254.164-.469.055-1.273-.637-2.11-1.137-2.949-2.578-.223-.383.223-.356.637-1.184.07-.144.035-.27-.02-.379-.055-.11-.488-1.176-.668-1.61-.176-.421-.355-.362-.488-.37-.125-.008-.27-.008-.414-.008a.8.8 0 0 0-.578.27c-.2.218-.758.742-.758 1.808s.777 2.098.883 2.242c.11.145 1.527 2.332 3.703 3.274 1.375.593 1.914.644 2.601.543.418-.063 1.282-.524 1.461-1.032.18-.507.18-.941.125-1.03-.05-.099-.195-.153-.41-.259"
    ></path>
  </svg>
)

export default React.memo(LogoWhatsapp)
